import React, { useState } from 'react';
import ProductImages from 'components/quote_builder_widget/ProductImages';
import { useProductImagesSelection } from 'components/quote_builder_widget/ProductImagesTree';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const PRODUCT_IMAGES_SECTIONS = [
  { id: 'product_images_by_catalog_name', label: 'quote_builder_widget.section_product_images' },
];

// The images belong to the owner, not to this widget: every widget of theirs shows them.
const ProductImagesSection = ({ activeSection, onSectionChange, onChange }) => {
  const [imagesCount, setImagesCount] = useState();
  const { selection, clearSelection, onListChange, subtree } = useProductImagesSelection();
  const active = activeSubsection(PRODUCT_IMAGES_SECTIONS, activeSection);

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_product_images')}
      sections={PRODUCT_IMAGES_SECTIONS.map((section) => ({ ...section, count: imagesCount, subtree }))}
      activeId={selection ? undefined : active.id}
      onSectionChange={(section) => {
        clearSelection();
        onSectionChange(section);
      }}
    >
      <div className={styles.fieldGroup}>
        <ProductImages onChange={onChange} onCountChange={setImagesCount} onListChange={onListChange} selection={selection} />
      </div>
    </SectionMenuLayout>
  );
};

export default ProductImagesSection;
